import api from './axiosInstance';

export const getPlatforms = async () => {
    const response = await api.get("/platforms");
    return response.data;
};

export const setPlatformEmail = async (email, platformId, userId) => {
    const response = await api.post(`/platforms/${platformId}/setEmail`, { email, userId });
    return response.data;
}